import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min.js";
import { fetchApiData } from "../../store/slicers/apiSlicer.js";
import AppLayout from "../layouts/AppLayout.jsx";

const ContentInformationDetail = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [information, setInformation] = useState(null);
  const [currentLang, setCurrentLang] = useState(() => {
    return localStorage.getItem("onpr_language") || "fr";
  });

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.informations,
    isLoading: state.apiData?.loading?.informations,
  }));

  useEffect(() => {
    if (!data) {
      dispatch(
        fetchApiData({
          url: "informations",
          itemKey: "informations",
        })
      );
    }
  }, []);

  useEffect(() => {
    if (data?.data) {
      const info = data.data.find((i) => i.id === parseInt(id));
      if (info) {
        setInformation(info);
      }
    }
  }, [data, id]);

  const handleLanguageChange = (lang) => {
    setCurrentLang(lang);
    localStorage.setItem("onpr_language", lang);
  };

  const handleBack = () => {
    history.push("/informations");
  };

  const getTitle = () => {
    if (!information) return "";
    return currentLang === "fr" ? information.title_fr : information.title_en;
  };

  const getDescription = () => {
    if (!information) return "";
    return currentLang === "fr"
      ? information.description_fr
      : information.description_en;
  };

  if (isLoading) {
    return (
      <div className="info-detail-screen">
        <div className="loading-container">
          <i
            className="pi pi-spin pi-spinner"
            style={{ fontSize: "3rem", color: "#00a652" }}
          ></i>
          <p>Chargement...</p>
        </div>
      </div>
    );
  }

  if (!information) {
    return (
      <div className="info-detail-screen">
        <div className="error-container">
          <i
            className="pi pi-exclamation-triangle"
            style={{ fontSize: "3rem", color: "#d32f2f" }}
          ></i>
          <h2>Information introuvable</h2>
          <button className="back-btn" onClick={handleBack}>
            <i className="pi pi-arrow-left"></i> Retour
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="info-detail-screen">
      <article className="detail-content">
        <div className="detail-meta">
          <span className="detail-date">
            <i className="pi pi-calendar"></i>{" "}
            {new Date(information.created_at).toLocaleDateString("fr-FR")}
          </span>
        </div>

        <h1 className="detail-title">{getTitle()}</h1>
        <div
          className="detail-body"
          dangerouslySetInnerHTML={{ __html: getDescription() }}
        ></div>
      </article>

      <style jsx>{`
        .info-detail-screen {
          max-width: 1200px;
          margin: 30px auto;
          padding: 0 20px;
        }
        .loading-container,
        .error-container {
          text-align: center;
          padding: 100px 20px;
        }
        .loading-container p,
        .error-container h2 {
          margin-top: 20px;
          color: #00a652;
        }
        .detail-header {
          margin-bottom: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 15px;
        }
        .back-btn {
          background: #00a652;
          color: white;
          border: none;
          padding: 12px 24px;
          border-radius: 5px;
          cursor: pointer;
          font-size: 1rem;
          transition: all 0.3s;
          display: inline-flex;
          align-items: center;
          gap: 10px;
        }
        .back-btn:hover {
          background: #d32f2f;
          transform: translateX(-5px);
        }
        .detail-content {
          background: white;
          border-radius: 15px;
          padding: 40px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        }
        .detail-meta {
          margin-bottom: 20px;
        }
        .detail-date {
          color: #d32f2f;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .detail-title {
          color: #00a652;
          font-size: 2.5rem;
          margin-bottom: 30px;
          line-height: 1.3;
        }
        .detail-body {
          color: #333;
          font-size: 1.1rem;
          line-height: 1.8;
        }
        .detail-body p {
          margin-bottom: 20px;
        }
        .detail-body h1,
        .detail-body h2,
        .detail-body h3 {
          color: #00a652;
          margin-top: 30px;
          margin-bottom: 15px;
        }
        .detail-body img {
          max-width: 100%;
          height: auto;
          margin: 15px 0;
        }
        @media (max-width: 768px) {
          .detail-title {
            font-size: 1.8rem;
          }
          .detail-content {
            padding: 20px;
          }
          .detail-header {
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>
    </div>
  );
};

const InformationDetail = () => {
  return (
    <>
      <AppLayout>
        <ContentInformationDetail />
      </AppLayout>
    </>
  );
};

export default InformationDetail;
